exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".certificate-description-content[data-v-383941a6]{max-height:60vh;overflow-y:auto;word-break:break-word}", ""]);

// exports
